import React, { FC, useState } from 'react';
import { Card, Row, Col } from 'antd';
import COButton from 'shared/components/COButton';
import LoaderAnimation from 'shared/components/LoaderAnimation';
import styles from '../activityDataEntry.module.scss';
import { ButtonSize } from 'enums/ButtonEnums';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import OrganizationModal from 'shared/components/OrganizationModal';
import { Location } from 'models/ActivityDataEntryLocation/location.model';
import clsx from 'clsx';
import EditLocationForm from './EditLocationForm';
import { OrganizationMetaData } from 'models/OrganizationMetaData.ts';
import { Address } from 'models/Address/address.model';

interface LocationDetailsProps {
  scopeLoading?: boolean;
  locationDetails?: Location;
  orgListMeta?: OrganizationMetaData[];
  updateLocation?: (
    locationId?: number | undefined,
    payload?: Location | undefined
  ) => Promise<void>;
  fetchLocation?: (locationId?: number | undefined) => Promise<void>;
}

const LocationDetails: FC<LocationDetailsProps> = ({
  scopeLoading,
  locationDetails,
  orgListMeta,
  updateLocation,
  fetchLocation,
}) => {
  const [isLocationEdit, setIsLocationEdit] = useState(false);
  const handleEdit = () => setIsLocationEdit(true);

  return (
    <Card className={styles.cardContainer}>
      <div className={styles.cardWrapper}>
        {scopeLoading ? (
          <div className={styles.scopeLoadingContainer}>
            <LoaderAnimation />
          </div>
        ) : (
          <EditLocationForm
            setIsLocationEdit={setIsLocationEdit}
            locationDetails={locationDetails}
            orgListMeta={orgListMeta}
            updateLocation={updateLocation}
            fetchLocation={fetchLocation}
            handleEdit={handleEdit}
            isLocationEdit={isLocationEdit}
          />
        )}
      </div>
    </Card>
  );
};

export default LocationDetails;
